import React, {useEffect, useState} from 'react';
import GridPage from "../../grids/gridPage";
import {dictionaries} from "./dictionaries";
import './styles.scss';
import {queryStringToObject} from "../../services/utils";

const DictionaryList = ({history, match, location}) => {
    const name = match.params.name;
    const [dictionaryData, setDictionaryData] = useState({});

    useEffect(() => {
        const d = dictionaries.find(d => d.key === name);
        d ? setDictionaryData(d) : history.push('/');
    }, [name])

    const label = dictionaryData.label;
    const columns = dictionaryData.columns;
    const preFilters = queryStringToObject(location.search);

    return (
        <div>
            <GridPage
                history={history}
                gridName={name}
                label={label}
                columns={columns}
                isDictionary
                dictionaryData={dictionaryData}
                preFilters={Object.keys(preFilters).length ? preFilters : null}
            />
        </div>
    );
};

export default DictionaryList;


// WEBPACK FOOTER //
// ./App/pages/dictionaries/dictionaryList.jsx